<template>
  <v-text-field v-bind="$props"
                v-model="inputValue">

    <!-- PREPEND SLOTS -->
    <template v-slot:prepend>
      <slot name="prepend-outer" />
    </template>

    <template v-slot:prepend-inner>
      <slot name="prepend" />
    </template>
    <!------------------->

    <!-- APPEND SLOTS -->
    <template v-slot:append>
      <slot name="append">
        <v-progress-circular v-if="loading"
                             indeterminate
                             size="20"
                             width="2"
                             color="primary">
        </v-progress-circular>
      </slot>
    </template>

    <template v-slot:append-outer>
      <slot name="append-outer" />
    </template>
    <!------------------->

  </v-text-field>
</template>


<script>
export default {
  name: "TextFieldTimeout",
  props: {
    value: String,
    clearIconCb: Function,
    outlined: String,
    dense: Boolean,
    solo: Boolean,
    flat: Boolean,
    rounded: String,
    light: Boolean,
    hideDetails: String,
    singleLine: Boolean,
    label: String,
    clearable: Boolean,
    loading: Boolean,
    timeout: {
      type: Number,
      default: () => 400,
    },
  },

  data: () => ({
    inputValue: "",
    searchTimeout: null,
    awaitingSearch: false,
  }),

  watch: {
    inputValue(val) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      if (val) {
        //if (val.length < 2) return; // ignore if less (no emits)
        this.searchTimeout = setTimeout(() => {
          
          this.$emit("input", this.inputValue);
          this.awaitingSearch = false;
          this.searchTimeout = null;
        }, this.timeout);
      } else {
        this.$emit("input", "");
      }
    },

    value() {
      if (this.value != this.inputValue) {
        this.inputValue = this.value;
      }
    },
  },
};
</script>

<style lang="scss">
.v-text-field--outlined .v-input__append-outer {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
</style>